import i18next from 'i18next';



const dettaglio = {
    label: "DETTAGLIO",
    nomeKeyServizio: "statoPratica",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"dettaglio"

}
const codiceInvio = {
    label: "CODICE_INVIO",
    nomeKeyServizio: "idPratica",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const uffDestinaz = {
    label: "UFFICIO_DESTINAZIONE",
    nomeKeyServizio: "uffDestinaz",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const protocolloPlico = {
    label: "PROTOCOLLO_PLICO",
    nomeKeyServizio: "protocolloPlico",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const ente = {
    label: "ENTE",
    nomeKeyServizio: "ente",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const utc =
    {
        label: "IDENTIFICATIVO_UNIVOCO_UTC",
        nomeKeyServizio: "utc",
        classNameHeader: "text-center ",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        type:"text"

    }
const idMnemonico = {
    label: "IDENTIFICATIVO_MNEMONICO",
    nomeKeyServizio: "idPraticaMittente",
    classNameHeader: "text-center ",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const dataTrasmissione = {
        label: "DATA_TRASMISSIONE",
        nomeKeyServizio: "timestampInvio",
        classNameHeader: "text-center ",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        type:"text"

    }
const statoPratica = {
    label: "STATO_PRATICA",
    nomeKeyServizio: "descStato",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const ricevutaTrasmissione = {
    label: "RICEVUTA_TRASMISSIONE",
    nomeKeyServizio: "statoPratica",
    file: "rdt",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"ricevutaFirmataENon",
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_P7M',
    titlePdf:['RICEVUTA_DI_TRASMISSIONE','RICEVUTA_DI_TRASMISSIONE_KO'],
    titleP7m:['RICEVUTA_DI_TRASMISSIONE_FIRMATA','RICEVUTA_DI_TRASMISSIONE_FIRMATA_KO']

}
const ricevutaRicezione = {
    label: "RICEVUTA_RICEZIONE",
    file: "crp",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"ricevutaFirmataENon",
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_RICEZIONE_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_RICEZIONE_P7M',
    titlePdf:['RICEVUTA_DI_RICEZIONE','RICEVUTA_DI_RICEZIONE_KO'],
    titleP7m:['RICEVUTA_DI_RICEZIONE_FIRMATA','RICEVUTA_DI_RICEZIONE_FIRMATA_KO']

}

const ricevutaEsecuzione = {
    label: "RICEVUTA_ESECUZIONE",
    file: "cre",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"ricevutaFirmataENon",
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_ESECUZIONE_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_ESECUZIONE_P7M',
    titlePdf:['RICEVUTA_DI_ESECUZIONE','RICEVUTA_DI_ESECUZIONE_KO'],
    titleP7m:['RICEVUTA_DI_ESECUZIONE_FIRMATA','RICEVUTA_DI_ESECUZIONE_FIRMATA_KO']

}

const documentoInviato = {
    label: "DOCUMENTO_INVIATO",
    nomeKeyServizio: "p7m",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"downloadDocumento",
    file:"p7m",
    icon:"far fa-file fa",
    spanSrOnly:"BUTTON_DOWNLOAD_P7M",}

    const fornituraOnDemandCI = {
        label: "FORNITURA",
        nomeKeyServizio: "",
        classNameHeader: "text-center",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        type:"fornituraOnDemandCI",
        file:"",
        icon:"far fa-file fa",
        spanSrOnly:"BUTTON_DOWNLOAD_P7M",}

const certificatoProdotto = {
        label: "CERTIFICATO_PRODOTTO",
        nomeKeyServizio: "certPDF",
        classNameHeader: "text-center",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        idAtmos: 1,
        type:"downloadDocumentoAtmos",
        file:"certPDF",
        icon:"far fa-file fa",
        spanSrOnly:"BUTTON_DOWNLOAD_CER",}

const ricevutaPagamento={
        label: "RICEVUTA_PAGAMENTO",
        file: "rdp",
        classNameHeader: "text-center",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_PDF',
        spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_P7M',
        type:"ricevutaFirmataENon",
        titlePdf:['',''],
        titleP7m:['','']
    
        }

const progressivo={
    label: "PROGRESSIVO",
    nomeKeyServizio:"progPnp",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const colonnaServizioStatoPratica={
    label:"STATO",
    nomeKeyServizio:"statoPratica",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"servizioStatoPratica"
}
const protocolloUfficio={
    label: "PROTOCOLLO_UFFICIO",
    nomeKeyServizio:"protocolloUfficio", 
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const numeroPresentazione={
    label: "NUMERO_PRESENTAZIONE",
    nomeKeyServizio:"numPresent", 
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const numeroGenerale={
    label: "NUMERO_GENERALE",
    nomeKeyServizio:"numReg", 
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const duplo = {
    label: "DUPLO",
    nomeKeyServizio: "esito",
    condizione: 2,
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"downloadDocumento",
    file:"duploPositivo",
    icon:"far fa-file fa",
    spanSrOnly:"BUTTON_DOWNLOAD_DUPLO"}
    
const duploNegativo = {
        label: "DUPLO_NEGATIVO",
        nomeKeyServizio: "esito",
        condizione: 3,
        classNameHeader: "text-center",
        classNameCella: "text-center",
        livello: 1,
        rowSpan: 2,
        type:"downloadDocumento",
        file:"duploNegativo",
        icon:"far fa-file fa",
        spanSrOnly:"BUTTON_DOWNLOAD_DUPLO_NEGATIVO"
    }

const repertorioRaccolta = {
    label: "REPERTORIO",
    nomeKeyServizio:"repertorioRaccolta",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const primoNumeroRepertorio = {
    label: "REPERTORIO",
    nomeKeyServizio:"primoNumeroRepertorio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const secondoNumeroRepertorio = {
    label: "REPERTORIO2",
    nomeKeyServizio:"secondoNumeroRepertorio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const destinazione = {
    label: "DESTINAZIONE",
    nomeKeyServizio:"elaborazione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const registrazione = {
    label: "REGISTRAZIONE",
    nomeKeyServizio:"registrazione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const anomalieUN = {
    label: "ANOMALIE",
    nomeKeyServizio: "idPratica",
    classNameHeader: "text-center text-nowrap",
    livello: 1,
    colSpan: 3,
    type:"td-none"

}

const anomalieMP = {
    label: "ANOMALIE",
    nomeKeyServizio: "idPratica",
    classNameHeader: "text-center text-nowrap",
    livello: 1,
    colSpan: 2,
    type:"td-none"

}
const pegni = {
    label: "PEGNI",
    nomeKeyServizio: "esitoTerritorio",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"nsr",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}
const generali = {
    label: "ANOMALIE_GENERALI",
    nomeKeyServizio: "esitoTelematico",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaTelematico",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const entrate = {
    
        label: "ANOMALIE_ENTRATE",
        nomeKeyServizio: "esitoEntrate",
        classNameHeader: "text-center",
        classNameCella: "text-center",
        livello: 2,
        type:"downloadDocumento",
        file:"anomaliaEntrate",
        icon:"far fa-file-pdf fa",
        spanSrOnly:"BUTTON_DOWNLOAD_ENTRATE",
        warning:"1",
        
}

const entratePegni = {
    
    label: "ANOMALIE_ENTRATE_PEGNI",
    nomeKeyServizio: "esitoEntrate",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"rsr",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_ENTRATE",
    warning:"1",
    
}

const territorio = {
    label: "ANOMALIE_TERRITORIO",
    nomeKeyServizio: "esitoTerritorio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaCatasto",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const conservatorie = {
    label: "ANOMALIE_CONSERVATORIE",
    nomeKeyServizio: "esitoNuoveConservatorie",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaPubblicitaImmobiliare",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const avvisi = {
    label: "AVVISI",
    nomeKeyServizio: "flagAvvisi",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"avviso"

}

const progressivoAvviso = {
    label: "PROGRESSIVO_AVVISO",
    nomeKeyServizio: "progAvviso",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const codiceAtto = {
    label: "CODICE_ATTO",
    nomeKeyServizio: "codiceAtto",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const tipoUfficio = {
    label: "TIPO_UFFICIO",
    nomeKeyServizio: "descTipoUfficio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const denominazioneUfficio = {
    label: "DENOMINAZIONE_UFFICIO",
    nomeKeyServizio: "denomUfficio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const dataAvviso = {
    label: "DATA_AVVISO",
    nomeKeyServizio: "dataAvviso",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}
const tipoAvviso = {
    label: "TIPO_AVVISO",
    nomeKeyServizio: "descTipoAvviso",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const esitoAvviso = {
    label: "ESITO_AVVISO",
    nomeKeyServizio: "descrizione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const ricevutaPagamentoIntegrativoAvviso = {
    label: "PAGAMENTO_INTEGRATIVO",
    nomeKeyServizio:"statoPratica",
    file: "idPagamento",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"pagamentoIntegrativo",
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_P7M',
    titlePdf:['RICEVUTA_DI_TRASMISSIONE','RICEVUTA_DI_TRASMISSIONE_KO'],
    titleP7m:['RICEVUTA_DI_TRASMISSIONE_FIRMATA','RICEVUTA_DI_TRASMISSIONE_FIRMATA_KO']

}

const documentoPreAvviso={
    label: "DOCUMENTO_PREAVVISO",
    file: "preAvvisoPagamento",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_P7M',
    type:"ricevutaFirmataENon",
    titlePdf:['',''],
    titleP7m:['','']

    }


const documentoAvviso={
    label: "DOCUMENTO_AVVISO",
    file: "avvisoPagamento",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    spanSrOnlyPdf:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_PDF',
    spanSrOnlyP7m:'BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_P7M',
    type:"ricevutaFirmataENon",
    titlePdf:['',''],
    titleP7m:['','']

    }

const dataPagamento={
    label: "DATA_PAGAMENTO",
    nomeKeyServizio: "dataPagamento",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const tipoNota={
    label: "TIPO_NOTA",
    nomeKeyServizio: "descrizioneNota",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const progressivoNota={
    label: "PROGRESSIVO",
    nomeKeyServizio: "progrNotaDisp",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const restituzioneDiParte={
    label: "RESTITUZIONE_DI_PARTE",
    nomeKeyServizio: "restituzioneDiParte",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"restituzioneDiParte"
}


const denomUfficio={
    label: "DENOMINAZIONE_UFFICIO",
    nomeKeyServizio: "denomUfficio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"
}

const esitoCons = {
    label: "ESITO",
    nomeKeyServizio: "idFileEco",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"idFileEco",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    
}
const esitoCat = {
    label: "ESITO",
    nomeKeyServizio: "idFileEca",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"idFileEca",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    
}

const esitoDuplo = {
    label: "DUPLO",
    nomeKeyServizio: "duplo",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"duplo",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    
}


const esitoVisura = {
    label: "VISURA",
    nomeKeyServizio: "idFileEvi",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"idFileEvi",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    
}
const anomalieCP = {
    label: "ANOMALIE",
    nomeKeyServizio: "erroreUtente",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
   // type:"text"
   type:"servizioStatoPratica"

}

const anomalieUnimod = {
    label: "ANOMALIE",
    nomeKeyServizio: "idPratica",
    classNameHeader: "text-center text-nowrap",
    livello: 1,
    colSpan: 4,
    type:"td-none"

}


const conservatorieAtmos = {
    label: "ANOMALIE_CONSERVATORIE",
    nomeKeyServizio: "esitoNuoveConservatorie",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaPubblicitaImmobiliareAtmos",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const territorioAtmos = {
    label: "ANOMALIE_TERRITORIO",
    nomeKeyServizio: "esitoTerritorio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaCatastoAtmos",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const generaliAtmos = {
    label: "ANOMALIE_GENERALI",
    nomeKeyServizio: "esitoTelematico",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaTelematicoAtmos",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const entrateAtmos = {
    
    label: "ANOMALIE_ENTRATE",
    nomeKeyServizio: "esitoEntrate",
    classNameHeader: "text-center",
    classNameCella: "text-center",
    livello: 2,
    type:"downloadDocumento",
    file:"anomaliaEntrateAtmos",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_ENTRATE",
    warning:"1",
    
}
const stampaNotaAtmos = {
    label: "STAMPA_NOTA",
    nomeKeyServizio: "stampaNotaAtmos",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"downloadDocumento",
    file:"stampaNotaAtmos",
    icon:"far fa-file-pdf fa",
    spanSrOnly:"BUTTON_DOWNLOAD_PEGNI",
    warning:"1",
}

const daLavorare = {
    label: "DA_LAVORARE",
    nomeKeyServizio: "daLavorare",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    rowSpan: 2,
    type:"text"

}

const daProtocollare = {
    label: "DA_PROTOCOLLARE",
    nomeKeyServizio: "daProtocollare",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const eseguite = {
    label: "ESEGUITE",
    nomeKeyServizio: "eseguite",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    rowSpan: 2,
    type:"text"

}

const irricevibili = {
    label: "IRRICEVIBILI",
    nomeKeyServizio: "irricevibili",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const mese = {
    label: "MESE",
    nomeKeyServizio: "mese",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const inseriteInRegistro = {
    label: "INSERITE_IN_REGISTRO",  
    nomeKeyServizio: "idPratica",
    classNameHeader: "text-center text-nowrap",
    livello: 1,
    colSpan: 3,
    type:"td-none"

}

const nonEseguibili = {
    label: "NON_ESEGUIBILI",
    nomeKeyServizio: "nonEseguibili",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 2,
    rowSpan: 2,
    type:"text"

}

const progressivoCI = {
    label: "PROGRESSIVO",
    nomeKeyServizio: "progressivo",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const tipoCanc = {
    label: "TIPO_CANCELLAZIONE",
    nomeKeyServizio: "tipoCanc",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}
const statoCanc = {
    label: "STATO_CANCELLAZIONE",
    nomeKeyServizio: "statoCanc",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const dataProtocollo = {
    label: "DATA_PROTOCOLLO",
    nomeKeyServizio: "dataProtocollo",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const codiceProtocollo = {
    label: "CODICE_PROTOCOLLO",
    nomeKeyServizio: "codiceProtocollo",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}


const numeroIscrizione = {
    label: "NUMERO_ISCRIZIONE",
    nomeKeyServizio: "numeroIscrizione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const dataIscrizione = {
    label: "DATA_ISCRIZIONE",
    nomeKeyServizio: "dataIscrizione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const dataCancellazione = {
    label: "DATA_CANCELLAZIONE",
    nomeKeyServizio: "dataCancellazione",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"text"

}

const anomalieUfficio = {
    label: "ANOMALIE_UFFICIO",
    nomeKeyServizio: "anomalieUfficio",
    classNameHeader: "text-center text-nowrap",
    classNameCella: "text-center",
    livello: 1,
    rowSpan: 2,
    type:"bottoneModale"

}

export const tableHeadPegni = 
[
    dettaglio,
    codiceInvio,
    utc,
    idMnemonico,
    dataTrasmissione,
    statoPratica,
    anomalieMP,
    pegni,
    entratePegni,
    ricevutaTrasmissione,
    ricevutaPagamento,
    documentoInviato,
    documentoAvviso
   


    




]

export const tableHeadPegniSecondoLivello = 
[
    progressivo,
    colonnaServizioStatoPratica,
    protocolloUfficio,
    numeroPresentazione,
    numeroGenerale,
    duplo,
    duploNegativo
]

export const tableHeadUnico = 
[
    dettaglio,
    codiceInvio,
    utc,
    idMnemonico,
    dataTrasmissione,
    statoPratica,
    ricevutaTrasmissione,
    documentoInviato
]

export const tableHeadUnicoSecondoLivello = [
    dettaglio,
    repertorioRaccolta,
   // destinazione,
    //registrazione,
    anomalieUN,
    generali,
    territorio, 
    conservatorie,
    //entrate,
    avvisi,
    
    
]


export const tableHeadUnicoTerzoLivelloCons = [
    tipoNota,
    progressivoNota,
    codiceAtto,
    denomUfficio,
    restituzioneDiParte,
    esitoCons,
    esitoDuplo,
    
    
]

    

export const tableHeadUnicoTerzoLivelloConsNoTitoloDigitale = [  
    tipoNota,
    progressivoNota,
    codiceAtto,
    denomUfficio,
    //restituzioneDiParte,
    esitoCons,
    esitoDuplo
]
export const tableHeadUnicoTerzoLivelloCat = [
    tipoNota,
    progressivoNota,
    codiceAtto,
    denomUfficio,
    esitoCat,
    esitoVisura
    
]

export const tableHeadUnicoAvvisiPagamento = [
    denominazioneUfficio,
    tipoAvviso,
    codiceAtto,
    dataAvviso,
    documentoPreAvviso,
    documentoAvviso,
    esitoAvviso,
    dataPagamento,
    ricevutaPagamentoIntegrativoAvviso,
]
export const tableHeadPegniCertificati = 
[
   // dettaglio,
    codiceInvio,
    utc,
    idMnemonico,
    dataTrasmissione,
    statoPratica,
    anomalieCP,
    //pegni,
  //  entratePegni,
    ricevutaTrasmissione,
    ricevutaPagamento,
    documentoInviato,
    certificatoProdotto
]

export const tableHeadUnimod = 
[
    //repertorioRaccolta,
    primoNumeroRepertorio,
    secondoNumeroRepertorio,
    anomalieUnimod,
    generaliAtmos,
    conservatorieAtmos,
    entrateAtmos,
    territorioAtmos,
    stampaNotaAtmos    
]
export const tableHeadCancIpotecaElenchi = 
[
    mese,
    daProtocollare,
    irricevibili,
    inseriteInRegistro,
    daLavorare,
    eseguite,
    nonEseguibili,
    fornituraOnDemandCI


]

export const tableHeadCancIpotecaPrimoLivello = 
[
    dettaglio,
    codiceInvio,
    uffDestinaz,
    dataTrasmissione,
    ente,
    statoPratica,
    protocolloPlico,
    ricevutaTrasmissione,
    ricevutaRicezione,
    ricevutaEsecuzione,
    documentoInviato
    


]

export const tableHeadCancIpotecaSecondoLivello = [
    progressivoCI,
    tipoCanc,
    statoCanc,
    dataProtocollo,
    codiceProtocollo,
    dataIscrizione,
    numeroIscrizione,
    dataCancellazione,
    anomalieUfficio

    
    
]

